import { Component, OnInit, Inject, Input } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from '../../../../environments/environment';
import { ConfirmModalComponent } from '../../components/confirm-modal/confirm-modal.component';
import { TCCPCommonService } from '../../services/tccp-common.service';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
  @Input() faqData: string = '';
  public faqImageURL = '../../../../assets/images/' + environment.applicationName + '/FAQLogo.png';
  public appName = environment.applicationName;
  public windowWidth: number;
  constructor(private dialog: MatDialog, private commonService: TCCPCommonService) { }

  ngOnInit() {
    this.windowWidth = window.innerWidth;
    // this.openFAQDialog();
  }

  openFAQDialog(): void {
    const FAQText = this.faqData && this.faqData !== undefined && this.faqData['faqs'] ?
      this.faqData['faqs'] : '';
    const dialogRef = this.dialog.open(FAQDialogComponent, {
      width: this.windowWidth && this.windowWidth > 768 ? this.windowWidth > 1800 ? '65vw' : '75vw' : '85vw',
      data: { title: 'FAQs', message: FAQText },
      position: { top: '50px' },
      id: this.appName + '-faq-popup'
    });
  }
}

@Component({
  selector: 'app-faq-dialog-component',
  templateUrl: './faq-dialog.html',
  styleUrls: ['./faq.component.scss']
})

export class FAQDialogComponent implements OnInit {
  public appName: string = environment.applicationName;
  public faqs = this.data;
  constructor(
    public commonService: TCCPCommonService,
    public dialogRef: MatDialogRef<FaqComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private dialog: MatDialog) {
  }

  ngOnInit() {
    console.log('faqs :::: ', this.faqs);
  }

  close(): void {
    this.dialogRef.close();
  }
}
